<template>
  <div>
    <h2 class="mb-4">Pages</h2>
    <div v-for="page in pages" :key="page.id" class="flex mb-2">
      <div class="w-3/4 br-grey-lighter">{{ page.current_revision.title }}</div>
      <div class="w-1/4 bg-grey-lightest">
        <a :href="frontendHostPath+page.urlAlias.path" class="flex-no-shrink border-transparent border-4 text-grey no-underline hover:text-grey-dark text-sm py-1 px-2 rounded" target="_blank">View</a>
        <button class="flex-no-shrink border-transparent border-4 text-blue-dark hover:text-blue-darkest text-sm py-1 px-2 rounded" type="button" @click="$router.push('/content/'+page.id)">
          Edit
        </button>
        <button class="flex-no-shrink border-transparent border-4 text-red hover:text-red-dark text-sm py-1 px-2 rounded" type="button" @click="$router.push('/content/'+page.id+'/delete')">
          Delete
        </button>
      </div>
    </div>
    <div class="flex justify-end">
      <button class="flex-no-shrink bg-blue-dark hover:bg-blue-darker border-blue-dark hover:border-blue-darker text-sm border-4 text-white py-1 px-2 rounded" type="button" @click="$router.push('/content/create')">
        Create New Content
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "arctic-vuejs-template";

export default {
  name: "contentOverview",
  data() {
    return {
      pages: {}
    };
  },
  computed: {
    frontendHostPath() {
      return process.env.VUE_APP_INSIDERS_APP_DOMAIN + "/";
    }
  },
  beforeMount() {
    console.log(process.env);
    api.get("/content").then(response => {
      console.log(response);
      this.pages = response.data;
    });
  }
};
</script>
